import {baseBackendUrl} from "../shared/constants";

export async function resetUserPassword(values, token) {
    const response = await fetch(`${baseBackendUrl}/auth/reset-password/${token}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ password: values.password }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Ошибка при сбросе пароля.');
}